@if (formState() !== 'mfa') {
  <form
    (ngSubmit)="continue()"
    class="flex flex-col">
    <label for="email">Email</label>
    <input
      #email
      type="email"
      name="email"
      id="email"
      [formField]="credentialsForm.email"
      autocapitalize="off"
      autocomplete="username"
      autofocus />
    <div [class.hidden]="formState() !== 'login'">
      <label for="password">Password</label>
      <div class="relative max-w-[320px]">
        <input
          #password
          [type]="showPassword() ? 'text' : 'password'"
          name="password"
          id="password"
          autocomplete="current-password"
          [formField]="credentialsForm.password"
          class="pr-9!" />
        <button
          type="button"
          (click)="togglePassword()"
          class="absolute top-1 right-1 flex h-7 w-7 items-center justify-center border-0 bg-transparent"
          [attr.aria-label]="
            showPassword() ? 'Hide password' : 'Show password'
          ">
          <i [class]="showPassword() ? 'icon-view' : 'icon-hidden'"></i>
        </button>
      </div>
    </div>

    <button
      btnType="submit"
      uiBtn
      [primary]="true"
      [loading]="checkingEmail()">
      Continue
    </button>

    @if (formState() === 'login') {
      <button
        class="flex"
        btnType="button"
        uiBtn
        [tertiary]="true"
        (click)="goBack()">
        Use a different email
      </button>
      <button
        btnType="button"
        uiBtn
        [tertiary]="true"
        (click)="resetPassword()">
        Reset password
      </button>
    }
  </form>
} @else {
  <form
    class="flex flex-col"
    (ngSubmit)="continue()">
    <label for="code">Enter code:</label>
    <anbs-code-input [formField]="mfaForm.code" />
    <div class="flex flex-row-reverse self-end">
      <button
        uiBtn
        btnType="submit"
        [primary]="true"
        #otpContinue>
        Continue
      </button>
      <button
        uiBtn
        [tertiary]="true"
        btnType="button"
        (click)="goBack()">
        Go back
      </button>
    </div>
  </form>
}
